import { render, staticRenderFns } from "./timeline.vue?vue&type=template&id=459a9aef&"
import script from "./timeline.vue?vue&type=script&lang=js&"
export * from "./timeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('459a9aef')) {
      api.createRecord('459a9aef', component.options)
    } else {
      api.reload('459a9aef', component.options)
    }
    module.hot.accept("./timeline.vue?vue&type=template&id=459a9aef&", function () {
      api.rerender('459a9aef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/timeline/timeline.vue"
export default component.exports